var _defs, _path, _path2, _rect, _path3, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccebf8;}.cls-2{fill:#707070;}.cls-3{fill:#66c4eb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63,35.3v14a14.59,14.59,0,1,1-29.17,0v-14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.4,64.47A15.19,15.19,0,0,1,33.23,49.3v-14H34.4v14a14,14,0,1,0,28,0v-14h1.16v14A15.18,15.18,0,0,1,48.4,64.47Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.82,
    y: 63.89,
    width: 1.17,
    height: 7.58
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.16,91.89H32.65V81.39h5a2,2,0,0,0,2-2V73.81H57.16v5.62a2,2,0,0,0,2,2h5ZM33.82,90.73H63V82.56H59.11A3.13,3.13,0,0,1,56,79.43V75H40.82v4.46a3.13,3.13,0,0,1-3.13,3.13H33.82Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.82,
    y: 30.63,
    width: 29.17,
    height: 1.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.63,41.73l.95,2.93a.8.8,0,0,0,.76.56h3.08a.23.23,0,0,1,.14.42l-2.49,1.81a.81.81,0,0,0-.3.9l1,2.93a.23.23,0,0,1-.36.26l-2.5-1.81a.78.78,0,0,0-.94,0l-2.49,1.81a.23.23,0,0,1-.36-.26l1-2.93a.81.81,0,0,0-.29-.9l-2.49-1.81a.23.23,0,0,1,.14-.42h3.08a.81.81,0,0,0,.76-.56l1-2.93A.24.24,0,0,1,48.63,41.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.63,5l.95,2.93a.8.8,0,0,0,.76.55h3.08a.23.23,0,0,1,.14.42l-2.49,1.81a.81.81,0,0,0-.3.9l1,2.93a.23.23,0,0,1-.36.26L48.87,13a.81.81,0,0,0-.94,0l-2.49,1.81a.23.23,0,0,1-.36-.26l1-2.93a.81.81,0,0,0-.29-.9L43.25,8.88a.23.23,0,0,1,.14-.42h3.08a.8.8,0,0,0,.76-.55l1-2.93A.24.24,0,0,1,48.63,5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.8,12.56l1,2.93a.8.8,0,0,0,.76.55h3.08a.24.24,0,0,1,.14.43l-2.49,1.81a.79.79,0,0,0-.3.89l1,2.94a.23.23,0,0,1-.36.26L64,20.55a.81.81,0,0,0-.94,0l-2.49,1.82a.23.23,0,0,1-.36-.26l1-2.94a.79.79,0,0,0-.29-.89l-2.49-1.81a.24.24,0,0,1,.14-.43h3.08a.8.8,0,0,0,.76-.55l1-2.93A.24.24,0,0,1,63.8,12.56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34,12.56l1,2.93a.8.8,0,0,0,.76.55h3.09a.24.24,0,0,1,.13.43l-2.49,1.81a.79.79,0,0,0-.29.89l1,2.94a.23.23,0,0,1-.36.26l-2.49-1.82a.81.81,0,0,0-.94,0l-2.5,1.82a.23.23,0,0,1-.36-.26l1-2.94a.79.79,0,0,0-.3-.89l-2.49-1.81A.24.24,0,0,1,28.8,16h3.08a.79.79,0,0,0,.76-.55l1-2.93A.23.23,0,0,1,34,12.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63,55.72H61.82V54.55H63c3.35,0,5.31-3.12,5.45-6.06.13-2.72-1.25-5.78-5.51-6.19l.12-1.16a6.77,6.77,0,0,1,6.55,7.41C69.44,52,67.06,55.72,63,55.72Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35,55.72H33.82c-4.07,0-6.45-3.7-6.62-7.17a6.78,6.78,0,0,1,6.56-7.41l.11,1.16c-4.26.41-5.63,3.47-5.5,6.19.14,2.94,2.1,6.06,5.45,6.06H35Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.15,
    y: 81.39,
    width: 15.75,
    height: 1.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy-icon.855bdc3300525b8220715bacb4f423ca.svg";
export { ForwardRef as ReactComponent };